import { inject, Injectable } from '@angular/core';
import { AuthService } from '@insolution/auth-data-access';
import { IUserStorageData } from '../interfaces/user-storage-data.interface';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private authService = inject(AuthService);

  public storeItem<T>(key: string, item: T): void {
    localStorage.setItem(key, JSON.stringify(item));
  }

  public getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public storeItemByUser<T extends keyof IUserStorageData>(key: T, item: IUserStorageData[T]): void {
    const getCurrentUser = this.authService.currentUser();

    const username = getCurrentUser ? getCurrentUser.username : 'guest';
    const userData = this.getItem<IUserStorageData>(`user_${username}`) || {};

    userData[key] = item;
    this.storeItem<IUserStorageData>(`user_${username}`, userData);
  }

  public getItemByUser<T extends keyof IUserStorageData>(key: T): IUserStorageData[T] | null {
    const getCurrentUser = this.authService.currentUser();

    const username = getCurrentUser ? getCurrentUser.username : 'guest';
    const userData = this.getItem<IUserStorageData>(`user_${username}`);

    return userData ? (userData[key] as IUserStorageData[T]) : null;
  }

  public removeItemByUser(key: keyof IUserStorageData): void {
    const getCurrentUser = this.authService.currentUser();

    const username = getCurrentUser ? getCurrentUser.username : 'guest';
    const userData = this.getItem<IUserStorageData>(`user_${username}`);

    if (userData && key in userData) {
      delete userData[key];
      this.storeItem<IUserStorageData>(`user_${username}`, userData);
    }
  }
}
